export default __webpack_public_path__ + "images/blog-list-feature.png?c5c1f590e47c11c65b93a75bc8f279d4";